/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StanceResult = {
    Pro: 'pro',
    Against: 'against',
    Neutral: 'neutral'
} as const;
export type StanceResult = typeof StanceResult[keyof typeof StanceResult];


export function instanceOfStanceResult(value: any): boolean {
    for (const key in StanceResult) {
        if (Object.prototype.hasOwnProperty.call(StanceResult, key)) {
            if (StanceResult[key as keyof typeof StanceResult] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StanceResultFromJSON(json: any): StanceResult {
    return StanceResultFromJSONTyped(json, false);
}

export function StanceResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): StanceResult {
    return json as StanceResult;
}

export function StanceResultToJSON(value?: StanceResult | null): any {
    return value as any;
}

export function StanceResultToJSONTyped(value: any, ignoreDiscriminator: boolean): StanceResult {
    return value as StanceResult;
}

